"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Loading_1 = require("../../components/loading/Loading");
require("./TopicsBlock.skeleton.scss");
var PHRASE_TRANSLATIONS = process.env.REACT_APP_MARKET_VALUES.PHRASE_TRANSLATIONS;
var TopicsBlockSkeleton = function (_a) {
    var _b = _a.length, length = _b === void 0 ? 9 : _b, _c = _a.isLayoutAdditional, isLayoutAdditional = _c === void 0 ? true : _c;
    var classNames = isLayoutAdditional ? 'topics-container-additional' : 'topics-container';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h1", { className: "accessibility-loading", children: PHRASE_TRANSLATIONS.htmlTitle }), (0, jsx_runtime_1.jsx)("ul", { className: classNames, "data-cy": "topics-list", children: Array(length)
                    .fill(0)
                    .map(function (_value, index) { return ((0, jsx_runtime_1.jsx)("li", { className: "list", children: (0, jsx_runtime_1.jsx)("div", { className: "topic-link", children: (0, jsx_runtime_1.jsx)(Loading_1.default, { marginTop: "1.5rem", width: "100%", height: "114px" }) }) }, index)); }) })] }));
};
exports.default = TopicsBlockSkeleton;
